export default __webpack_public_path__ + "static/media/image-study-board-1-w@3x.498dd27f.webp";